import { render, staticRenderFns } from "./ClosureNotice.vue?vue&type=template&id=7ef466fc&"
import script from "./ClosureNotice.vue?vue&type=script&lang=js&"
export * from "./ClosureNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports